import React from 'react';

import { Fab } from '@mui/material';

import {
  CREDIT_TIER,
  CREDIT_TIER_FIELD_DISPLAY,
  DEFAULT_TAB_STYLE,
  SELECTED_TAB_STYLE,
} from '../../constants/Dashboard/Financing';

import './CreditTierTabs.css';

export const CreditTierTabs = ({ selectedCreditTier, handleSelectCreditTier }) => {
  return (
    <div className="credit-tier-wrapper">
      <p className="auto-type-mileage-label" style={{ marginBottom: 0 }}>
        {CREDIT_TIER}
      </p>
      <div className="credit-tier-tabs-wrapper">
        {Object.keys(CREDIT_TIER_FIELD_DISPLAY).map((creditTierName) => {
          const additionalStyling = selectedCreditTier === creditTierName ? SELECTED_TAB_STYLE : {};
          return (
            <Fab
              key={creditTierName}
              sx={{
                ...DEFAULT_TAB_STYLE,
                fontSize: 10.5,
                ...additionalStyling,
              }}
              variant="extended"
              size="large"
              onClick={() => handleSelectCreditTier(creditTierName)}
            >
              {creditTierName}
              <br />
              {CREDIT_TIER_FIELD_DISPLAY[creditTierName].score}
            </Fab>
          );
        })}
      </div>
    </div>
  );
};
